import Link from 'next/link';

export const Footer = () => {
  return (
    <footer className="footer-area">
      <div className="container">
        <div className="footer-content text-center">
          
          <ul className="footer-menu">
            <li>
              <Link href="/">Home</Link>
            </li>
            <li>
              <Link href="/credentials">About</Link>
            </li>
            {/* <li>
              <Link href="/portfolio">Portfolio</Link>
            </li> */}
            {/* <li>
              <Link href="/posts">Blog</Link>
            </li> */}
            <li>
              <Link href="/contact">Contact</Link>
            </li>
          </ul>
          <p className="copyright">
            Made by 💙 <span>Shubham</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
